export interface FaqItem {
  q: string;
  a: string;
}

export const bcbsilFaqItems: FaqItem[] = [
  {
    q: "Does SAINT hurt?",
    a: "Most people describe a tapping feeling on the scalp. The most common side effects in clinical trials were mild headache and temporary scalp discomfort. You stay awake the whole time, with no anesthesia.",
  },
  {
    q: "Is SAINT safe?",
    a: "SAINT is FDA-cleared and noninvasive. More than 400 patients have been treated in clinical trials with no serious adverse events reported. Rare risks include seizure, and your clinician will review every risk with you.",
  },
  {
    q: "Will my BCBSIL plan cover it?",
    a: "It depends on your specific plan, and it requires prior authorization. We verify your benefits and handle the paperwork, and you'll know your cost before you commit. Coverage isn't guaranteed, and self-pay is available.",
  },
  {
    q: "Can family members on my plan be treated?",
    a: "Adults 22 and older on your plan whose depression hasn't improved with medication may be eligible. Each person gets their own free consultation.",
  },
  {
    q: "Do I need to get my own MRI?",
    a: "No. We order and coordinate your 45-minute brain scan for you.",
  },
  {
    q: "Where does treatment happen?",
    a: "At our clinic in Coral Springs, Florida. Your consultation happens over Zoom, and our travel coordinator helps you plan your treatment week.",
  },
];

export function BcbsilFaqSection() {
  return (
    <section className="py-14 sm:py-20 bg-muted">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-left">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <span className="inline-block text-xs uppercase tracking-wider font-semibold text-accent mb-1">
            Answers & Clarity
          </span>
          <h2 className="text-2xl sm:text-3xl font-semibold text-primary tracking-tight">
            Frequently Asked Questions
          </h2>
          <p className="text-sm sm:text-base text-foreground mt-2">
            Common questions from Blue Cross and Blue Shield of Illinois members
          </p>
        </div>

        {/* Semantic HTML details/summary accordions — 100% crawlable by bots */}
        <div className="space-y-3.5">
          {bcbsilFaqItems.map((item, idx) => (
            <details
              key={idx}
              className="group bg-white rounded-xl border border-border p-5 transition-all open:shadow-xs"
            >
              <summary className="flex items-center justify-between font-semibold text-base sm:text-lg text-primary cursor-pointer list-none select-none">
                <span>{item.q}</span>
                <span className="ml-4 shrink-0 text-accent transition-transform duration-200 group-open:rotate-45 text-xl font-bold">
                  +
                </span>
              </summary>
              <div className="mt-3.5 pt-3.5 border-t border-border/60 text-sm sm:text-base text-foreground leading-relaxed">
                {item.a}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
